
// import * as React from 'react';
// import Rating from '@mui/material/Rating';
// import Box from '@mui/material/Box';
// import StarIcon from '@mui/icons-material/Star';
// import { number } from '@mui/material';

// const labels: { [index: string]: string } = {
//   0.5: 'Useless',
//   1: 'Useless+',
//   1.5: 'Poor',
//   2: 'Poor+',
//   2.5: 'Ok',
//   3: 'Ok+',
//   3.5: 'Good',
//   4: 'Good+',
//   4.5: 'Excellent',
//   5: 'Excellent+',
// };

// function getLabelText(value: number) {
//   return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
// }

// export default function HoverRating() {
//   const [value, setValue] = React.useState<number | null>(2);
//   const [hover, setHover] = React.useState(-1);

//   return (
//     <Box sx={{ width: 200, display: 'flex', alignItems: 'center' }}>
//       <Rating
//         name="hover-feedback"
//         value={value}
//         precision={0.5}
//         getLabelText={getLabelText}
//         onChange={(event, newValue) => {
//           setValue(newValue);
//         }}
//         onChangeActive={(event, newHover) => {
//           setHover(newHover);
//         }}
//         emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
//       />
//       {value !== null && (
//         <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
//       )}
//     </Box>
//   );
// }




import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, Button, Rating, Table, TableBody, TableCell, TableHead, TableRow, Container } from "@mui/material";

const Ratings = () => {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const savedReviews = JSON.parse(localStorage.getItem("reviews")) || [];
    setReviews(savedReviews);
  }, []);

  useEffect(() => {
    localStorage.setItem("reviews", JSON.stringify(reviews));
  }, [reviews]);

  const handleSubmit = () => {
    if (rating > 0 && reviewText.trim()) {
      const newReview = { rating, text: reviewText };
      setReviews([...reviews, newReview]);
      setRating(0);
      setReviewText("");
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        REVIEWS & RATINGS
        
      </Typography>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6">Rate Our Service</Typography>
        <Rating
          name="rating"
          value={rating}
          precision={0.5}
          onChange={(event, newValue) => setRating(newValue)}
        />
      </Box>
      <TextField
        label="Write a Review"
        multiline
        rows={4}
        fullWidth
        value={reviewText}
        onChange={(event) => setReviewText(event.target.value)}
        sx={{ mb: 2 }}
      />
      <Button variant="contained" color="primary" onClick={handleSubmit}>
        Submit Review
      </Button>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          User Reviews
        </Typography>
        {reviews.length === 0 ? (
          <Typography>No reviews yet. Be the first to review!</Typography>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Rating</TableCell>
                <TableCell>Review</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reviews.map((review, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Rating value={review.rating} precision={0.5} readOnly />
                  </TableCell>
                  <TableCell>{review.text}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Box>
    </Container>
  );
};

export default Ratings;
